import React from 'react'
import Layout from '../../components/Layout'
import ContactForm from './ContactForm'
import MapAddress from './MapAddress'
import Footer from '../../components/Footer'

export const Contact = () => {
  return (
    <Layout >
      <ContactForm />
      <MapAddress />
      <Footer/>
    </Layout>
  )
}
export default Contact